const NS = 'ArticlesGridBlock';
const CLS = 'articlesGridBlock';

import Handlebars from 'handlebars';
import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';
import { initPagination } from '../../../../global/js/pagination';
import { utils } from '../../../../global/js/utils';
import { spinnerService } from '../../../../global/js/wlc/spinnerService';
import { ifCond } from '../../../../../handlebarsHelpers';

export class ArticlesGridBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.initAnimateScrollReveal(this, CLS);

		this.$pagination = this.$element.find(`.${CLS}-pagination`);
		this.$articlesList = this.$element.find(`.${CLS}-articlesList`);
		this.$articlesCate = this.$element.find(`.cate-dropdown-item`);
		this.$articlesSort = this.$element.find(`.sort-dropdown-item`);
		this.$dropdownCate = this.$element.find(`#dropdownCategories`);
		this.$dropdownSort = this.$element.find(`#dropdownSorting`);

		this.getApi = this.$element.data('articleApi');
		this.siteId = this.$element.data('siteId');
		this.pageSize = this.$element.data('pageSize');
		this.spinnerService = spinnerService;

		this.params = {
			siteId: this.siteId,
			pageNumber: 1,
			pageSize: this.pageSize,
			category: 'all',
			sort: 'nTo',
		};
		this.setItemTemplate();
		this.getItems(true);
		this.$element.on('pagination.trigger', () => {
			this.getItems(true);
		});
		this.handleArticlesCate();
		this.handleArticlesSort();
	}

		// Search Results Template
		setItemTemplate() {
			let itemPartial = require('../../../widgets/articlesCardWidget/tmpl/articlesCardWidget.hbs');
			Handlebars.registerPartial('articlesCardWidget', itemPartial);
	
			let template = `
				{{> articlesCardWidget
					wg="articlesCardWidget"
					ns="ArticlesCardWidget"
				}}
			`;
			let precompiled = new Function('return ' + Handlebars.precompile(template))();
			this.itemTemplate = Handlebars.template(precompiled);
			Handlebars.registerHelper('ifCond', ifCond);
		}
	
		// Get items (reload content)
		getItems(scrollToTop = false) {
			let url = this.getApi;

			if(!_.isEmpty(this.params)) {
				url += `?${$.param(this.params)}`;
			}
			

			this.$articlesList.empty();
			this.spinnerService.appendTo();
			this.updateUrl();

			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {
					let articles = data.results;
					let articlesTotal = data.totalCount;
					if(articles.length > 0) {
						articles.forEach((article) => {

							let itemMarkup = this.itemTemplate(article);
							this.$articlesList.append(`${itemMarkup}`);
						});
					}
					if(articlesTotal < 1){
						this.$articlesList.append("<h2 style='margin: 150px auto'>No Articles found</h2>");
					}
					
					if(scrollToTop) {
						this.$element.trigger('pagination.scrollToTop');
					}
	
					initPagination(data.pageSize, data.totalCount, this.$pagination, this);
					this.spinnerService.removeFrom();
				}
			});
		}
		
		handleArticlesCate() {
			this.$articlesCate.on('click', (event) => {
				let uri = document.location.pathname;
				this.params.category = $(event.target).data('id');
				this.$dropdownCate.html($(event.target).html());
				Object.keys(this.params).forEach((key, index) => {
					if(key == "category"){
						uri = utils.updateUrlParameter(uri, "category", this.params.category);
					}
					else{
						uri = utils.updateUrlParameter(uri, key, this.params[key]);
					}
				});
				window.history.pushState('', '', uri);
				this.getItems(true);
			});
		}

		handleArticlesSort() {
			this.$articlesSort.on('click', (event) => {
				let uri = document.location.pathname;
				this.params.sort = $(event.target).data('id');
				this.$dropdownSort.html($(event.target).html());
				Object.keys(this.params).forEach((key, index) => {
					if(key == "sort"){
						uri = utils.updateUrlParameter(uri, "sort", this.params.sort);
					}
					else{
						uri = utils.updateUrlParameter(uri, key, this.params[key]);
					}
				});
				window.history.pushState('', '', uri);
				this.getItems(true);
			});
		}

		// Update url after filters change
		updateUrl() {
			let uri = document.location.pathname;
			
			Object.keys(this.params).forEach((key, index) => {
				uri = utils.updateUrlParameter(uri, key, this.params[key]);
			});
			// update url without reload
			window.history.pushState('', '', uri);
		}
}

Object.assign(ArticlesGridBlock.prototype, animateScrollRevealMixinBlock);
